import * as React from 'react'
import Loadable from 'react-loadable'
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { getUrlSearch, isChinese } from '@src/utils'
import ErrorC from '@components/error'
import ErrorGlobal from '@componentsG/error'
import PageLoadingC from '@components/pageLoading'
import { userStore } from '@src/store' // 引入用户的URL
import GlobalApp from '@shared/App/indexG'
import JumpToWeApp from '@views/jumpToWeapp'
import DongleToWeApp from '@views/dongleToWeapp'
import ShareToWeApp from '@views/shareToWeApp'
import FAQ from '@views/faq'
import Wizard from '@views/wizard'
import Gift from '@views/gift'
import MonthlySign from '@views/monthlySign'
import TrafficActivities from '@views/trafficActivities'
import LifetimeTrafficActivities from '@views/lifetimeTrafficActivities'
import AiZone from '@views/AiZone'
import Weixin from '@views/weixin'
import AiZoneHistory from '@views/AiZoneHistory'
import Questionnaire from '@views/questionnaire'
import XiaoTianTraffic from '@views/XiaoTianTraffic'
import XiaoTianPackage from '@views/XiaoTianPackage'
import XiaoTianStartApp from '@views/XiaoTianStartApp'
import SeatSystem from '@views/seatSystem'
import Dsr from '@views/dsr'
import EsimApp from '@shared/App/indexE.tsx'

const Login = Loadable({
    loader: () => import('@views/login/index.tsx'),
    loading: PageLoadingC
})
const ReceiveCouponForLive = Loadable({
    loader: () => import('@views/receiveCouponForLive'),
    loading: PageLoadingC
})
const UserGuide = Loadable({
    loader: () => import('@views/userGuide'),
    loading: PageLoadingC
})

const App = Loadable({
    loader: () => import('@shared/App'),
    loading: PageLoadingC
})
const routerNeedLogin = () => {
    return location.href.indexOf('app/home') > -1 || location.href.indexOf('app/mine') > -1 || location.href.indexOf('app/ordering') > -1 || location.href.indexOf('app/change-package') > -1
}
const Repurchase = Loadable({
    loader: () => import('@views/repurchase'),
    loading: PageLoadingC
})
// 权限控制
const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props =>
                !userStore.userInfo.lenovoId && routerNeedLogin()
                    ? (<Redirect to={{ pathname: '/login', state: { from: props.location } }} />)
                    : (<Component {...props} />)
            }
        />
    )
}
// 海外权限控制
const PrivateRouteG = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => <Component {...props} />}
        />
    )
}
// 添加 PrivateRouteE
const PrivateRouteE = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => <Component {...props} />}
        />
    )
}
const AppRouter = () => {
    const chl = getUrlSearch().chl
    if (chl) {
        localStorage.setItem('chl', chl);
        userStore.sendEventTracing({
            pageCode: 'channel',
            buttonCode: chl,
            buttonInfo: ''
        })
    }
    return (
        <Router>
            <Switch>
                <Route exact path="/" render={() => <Redirect exact to={isChinese() ? 'login' : '/global/login'} push />} />
                <Route exact path="/login" component={Login} />
                <Route exact path="/receive-coupon/:id" component={ReceiveCouponForLive} />
                <Route path="/userGuide" component={UserGuide} />
                <Route path="/jump-to-weApp" component={JumpToWeApp} />
                <Route path="/faq" component={FAQ} />
                <Route path="/questionnaire" component={Questionnaire} />
                <Route path="/dsr/:code" component={Dsr} />
                <Route path="/wizard" component={Wizard} />
                <Route path="/gift" component={Gift} />
                <Route path="/monthlySign" component={MonthlySign} />
                <Route path="/trafficActivities" component={TrafficActivities} />
                <Route path="/lifetimeTrafficActivities" component={LifetimeTrafficActivities} />
                <Route path="/AiZone" component={AiZone} />
                <Route path="/AiZoneHistory" component={AiZoneHistory} />
                <Route path="/XiaoTianTraffic" component={XiaoTianTraffic} />
                <Route path="/XiaoTianPackage" component={XiaoTianPackage} />
                <Route path="/XiaoTianStartApp" component={XiaoTianStartApp} />
                <Route path="/seatSystem/:randomCode" component={SeatSystem} />
                <Route path="/weixin" component={Weixin} />
                <Route path="/repurchase" component={Repurchase} />
                <Route path="/dongle-to-weApp" component={DongleToWeApp} />
                <Route path="/share-to-weApp" component={ShareToWeApp} />
                <PrivateRoute path="/app" component={App} />
                <PrivateRouteG path="/global" component={GlobalApp} />
                <PrivateRouteE path="/esim" component={EsimApp} />
                <Route component={isChinese() ? ErrorC : ErrorGlobal} />
            </Switch>
        </Router>
    )
}

export default AppRouter
